"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.acceptFlowMarketingParams = void 0;
exports.acceptFlowMarketingParams = "utm_source=qwilr-branding&utm_medium=qwilr-accept-flow&utm_campaign=powered-by-qwilr";
